<template>
  <div class="Contract">
    <div class="flex-jc-bt main">
      <div class="flex-60 left-side text-left">
        <sp-card class="card" custom-class="sp-color-bg-4">
          <div style="padding-top: 40px">
            <div class="content-form flex-jc-start">
              <div class="flex-1">
                <div class="flex-al-center flex-jc-start">
                  <div class="pd-r-10 right text-right">
                    <SpSelect v-model="contractInfo.title"
                              name="title"
                              :show-clear="false" class="" :need-search="false"
                              style=" float: right" type="warn" height="40">
                      <SpSelectOption v-for="app in userTitle" :key="app" :label="app" :value="app" />
                    </SpSelect>
                  </div>
                  <div class="flex-1" style="position: relative">
                    <div class="flex-al-center flex-jc-start">
                      <div class="flex-50">
                        <span v-required class="fn-span font16 italic-bold">{{ $l('MyName') }}</span>
                        <spInput v-model="contractInfo.firstName"
                                 name="firstName"
                                 placeholder="English"
                                 row="3" height="40" required type="warn" />
                      </div>
                      <div class="flex-50 pd-l-30">
                        <span v-required class="fn-span font16 italic-bold">{{ $l('CodeName') }}</span>
                        <spInput v-model="codeName"
                                 :disabled="codeNameDisabled"
                                 name="codeName"
                                 :type="codeNameDisabled ? 'gray' : 'warn'"
                                 placeholder="English" row="3" height="40" required />
                      </div>
                    </div>
                  </div>
                  <div class="icon-panel"><span v-if="!modelValue.codeName" class="icon-edit-1 iconfont" @click="codeNameDisabled = !codeNameDisabled" /></div>
                </div>

                <div class="flex-al-center flex-jc-start" style="margin-top: 4px">
                  <div class="pd-r-10 right text-right" />
                  <div class="flex-1" style="position: relative">
                    <div class="flex-al-center flex-jc-start">
                      <div class="flex-50">
                        <spInput v-model="contractInfo.nativeName"
                                 name="nativeName"
                                 placeholder="Native Language"
                                 row="3" height="40" type="warn2" />
                      </div>
                      <div class="flex-50 pd-l-30" />
                    </div>
                  </div>
                  <div class="icon-panel" />
                </div>
                <div class="flex-al-center flex-jc-start mg-t-30">
                  <div class="pd-r-10 right text-right" />
                  <div class="flex-1" style="position: relative">
                    <div class="flex-al-center flex-jc-start">
                      <span v-required class="fn-span font16 italic-bold">{{ $l('FamilyName') }}</span>
                      <div class="flex-50">
                        <spInput v-model="contractInfo.lastName"
                                 name="lastName"
                                 placeholder="English" row="3" height="40" required type="warn" />
                      </div>
                      <div class="flex-50 pd-l-30" />
                    </div>
                  </div>
                  <div class="icon-panel" />
                </div>
                <div class="flex-al-center flex-jc-start mg-t-30">
                  <div class="pd-r-10 right text-right" />
                  <div class="flex-1" style="position: relative">
                    <div class="flex-al-center flex-jc-start">
                      <span v-required class="fn-span font16 italic-bold" style="left: 70px">{{ $l('Country') }}</span>
                      <div class="flex-50">
                        <SpSelect v-model="contractInfo.countryId" required name="countryId" strategy="fixed" height="42" :placeholder="$l('countryPlaceHolder')" type="warn" @after-select="searchCity">
                          <SpSelectOption v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id" />
                        </SpSelect>
                      </div>
                      <div class="flex-50">
                        <div class="flex-al-center flex-jc-start">
                          <div class="text-center" style="width: 30px;">—</div>
                          <div class="flex-1">
                            <SpSelect v-model="contractInfo.cityId"
                                      :disabled="!contractInfo.countryId"
                                      name="cityId" height="42" required strategy="fixed" :placeholder="$l('City')" type="warn" @search="searchCityByKey">
                              <SpSelectOption v-for="item in citys" :key="item.id" :label="item.name" :value="item.id" />
                            </SpSelect>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="icon-panel" />
                </div>

                <div class="flex-al-center flex-jc-start" style="margin-top: 4px">
                  <div class="pd-r-10 right text-right" />
                  <div class="flex-1" style="position: relative">
                    <div class="flex-al-center flex-jc-start">
                      <div class="flex-50 text-right">
                        {{ contractInfo.phonecode }}
                      </div>
                      <div class="flex-50">
                        <div class="flex-al-center flex-jc-start">
                          <div class="text-center" style="width: 30px;">—</div>
                          <div class="flex-1">
                            <spInput v-model="contractInfo.cityPhonecode" class="size-8" width="44" height="24" row="3" name="cityPhonecode" type="warn2" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>
              <div style="width: 198px" class="avatar-panel pd-l-30">
                <div class="avatar-select">
                  <p class="font16 italic name-label sp-color-18">{{ $l('HeadPortrait') }}</p>

                  <SpUploadGroup ref="avatar-upload" max-count="1" width="198" height="240"
                                 :default-files="$store.state.user.user.avatar?[{type:'img',url:$store.state.user.user.avatar}]:[]"
                                 file-type="user/avatar" :business-id="$store.state.user.user.userId"
                                 class="avatar-uploader" action="#" :show-file-list="false"
                                 list-type="picture-card" :on-change="avatarSelected" :auto-upload="false" />
                </div>
              </div>
            </div>
            <p v-triangle class="font18 head">{{ $l('PrivateInformation') }}</p>
            <div class="content-form flex-jc-start">
              <div class="flex-1">
                <div class="label-content mg-t-20">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span v-required class="font16 fw-bold italic pd-r-10">{{ $l('MobilePhone') }}</span>
                    </div>
                    <div class="flex-1">
                      <div class="flex-al-center flex-jc-start">
                        <div class="tel-area" :style="'width:'+mobileCodeWidth+'px'" style="height: 42px; font-size: 14px;">
                          {{ contractInfo.phonecode }}
                        </div>
                        <div class="flex-1">
                          <spInput v-model="contractInfo.mobileNo" required height="42" name="mobileNo" type="warn" />
                        </div>
                      </div>
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>

                <div class="label-content mg-t-20">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span v-required class="font16 fw-bold italic pd-r-10">{{ $l('EmailAddress') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.emails" height="42" name="emails" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
                <div class="label-content" style="margin-top: 4px">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('Skype') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.skype" height="42" name="skype" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>

                <div class="label-content mg-t-20">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('Yahoo') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.yahoo" height="42" name="yahoo" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
                <div class="label-content" style="margin-top: 4px">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('WhatsApp') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.whatsapp" height="42" name="whatsapp" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>

                <div class="label-content mg-t-20">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('WeChat') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.wechat" height="42" name="wechat" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
                <div class="label-content" style="margin-top: 4px">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right">
                      <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('QQ') }}</span>
                    </div>
                    <div class="flex-1">
                      <spInput v-model="contractInfo.qq" height="42" name="qq" type="warn" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>

                <div class="label-content" style="margin-top: 4px">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="label pd-r-10 text-right" />
                    <div class="flex-1">
                      <p class="fw-bold">{{ $l('OtherContacts') }}</p>
                      <sp-input v-model="modelValue.otherContacts" name="otherContacts" rows="4" text-type="textarea" type="warn2" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div style="width: 198px" class="avatar-panel pd-l-30" />
            </div>
            <div class="content-form flex-jc-start">
              <div class="flex-1">
                <div class="font18 fw-bold mg-b-10 mg-t-60">{{ $l('departmentInfo') }}</div>
                <BusinessCard :is-user="true" :left-width="210" />
              </div>
              <div style="width: 305px" class="avatar-panel pd-l-30" />
            </div>
          </div>
        </sp-card>
      </div>
      <div class="flex-38" style="padding-top: 39px">
        <div class="right-side">
          <div class="main text-left">
            <p class="fw-bold italic" style="margin: 0; position:relative; z-index: 7 ">{{ $l('PersonelSerialNo') }}</p>
            <div class="flex-jc-bt">
              <sp-input v-model="contractInfo.serialNo" name="serialNo" class="flex-70" type="gray" disabled style="position:relative; top: -2px;z-index: 6" />
              <!--            <sp-input name="codeName" class="flex-25" type="warn" /> -->
            </div>
          </div>
          <div class="main text-left">
            <p class="font18 opacity-90 sp-color-11">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
            <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('Relevant certificates') }}</p>
            <div class="uploadFile">
              <SpUploadGroup ref="useCcert" file-type="user/cert"
                             :upload-after-select="!!contractInfo.id"
                             :default-files="userCert"
                             :business-id="$store.state.user.user.userId" />
            </div>

            <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('Others') }}</p>
            <div class="uploadFile">
              <SpUploadGroup ref="userOtherPic" file-type="user/other/pic"
                             :upload-after-select="!!contractInfo.id"
                             :default-files="userOtherPic"
                             :business-id="$store.state.user.user.userId" />
              <!--              <SpElUpload :default-files="userOtherPic" file-type="user/other/pic" -->
              <!--                          :business-id="$store.state.user.user.userId" /> -->
            </div>
            <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('WordExcelFiles') }}</p>
            <div class="uploadFile">
              <SpUpload
                file-type="user/other/file"
                :upload-after-select="!!contractInfo.id"
                :default-files="userOtherFile"
                :business-id="$store.state.user.user.userId" type="primary" />
            </div>
            <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('PosttheResumePictures') }}</p>
            <div class="uploadFile">
              <SpUploadGroup ref="userResume" file-type="user/resume"
                             :default-files="userResume"
                             :upload-after-select="!!contractInfo.id"
                             :business-id="$store.state.user.user.userId" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spInput from '@/components/common/SpInput'
import spIcon from '@/components/common/SpIcon'
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import SpCallingCard from '@/components/common/SpCallingCard'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpUpload from '@/components/common/SpUpload'
import { getCountrySpareList, getUserTitle, searchAddress } from '@/request/APIs/common'
import { formatFiles } from '@/utils/convert'
import BusinessCard from '@/components/natural/personalProfile/BusinessCard'
export default {
  name: 'Contract',
  nameSpace: 'natural.personalProfile.Contract',
  components: {
    BusinessCard,
    SpCallingCard,
    spInput,
    spIcon,
    spCard,
    spButton,
    SpSelect,
    SpSelectOption,
    SpUploadGroup,
    SpUpload
  },

  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },

  data () {
    return {
      // contractInfo: {},
      departmentInfo: {
        fullName: 'Qian An',
        familyName: 'Zhong',
        city: 'Singapore',
        country: 'Singapore',
        phone: '833770101'
      },

      userTitle: [],
      codeNameInfo: {
        lastName: '',
        firstName: '',
        codeName: ''
      },

      countryId: '',
      countrys: [],

      citys: [],
      codeNameDisabled: true
    }
  },

  computed: {
    codeName: {
      get () {
        const lastName = this.contractInfo?.lastName ? this.contractInfo?.lastName : ''
        const firstName = this.contractInfo?.firstName ? this.contractInfo?.firstName : ''
        let str = lastName + firstName
        str = str ? str.toUpperCase().replace(/[\s,\d]*/g, '') : ''
        let codeName = this.contractInfo.codeName || str
        codeName = codeName.replace(/[^a-zA-Z]/g, '')
        codeName = codeName.length > 12 ? codeName.slice(0, 12) : codeName + new Array(12 - codeName.length < 0 ? 0 : 12 - codeName.length).fill('X').join('')

        return codeName
      },

      set (nv) {
        this.contractInfo.code = nv
      }
    },

    contractInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    },

    // mobileCode () {
    //   return this.modelValue.cityPhonecode ? `${this.modelValue.phonecode} ${this.modelValue.cityPhonecode}` : `${this.modelValue.phonecode}`
    // },

    mobileCodeWidth () {
      return this.contractInfo?.phonecode?.length * 8 > 60 ? this.contractInfo.phonecode.length * 10 : 60
    },

    userCert () {
      return formatFiles(this.contractInfo, 'certificates')
    },

    userOtherPic () {
      return formatFiles(this.contractInfo, 'otherPics')
    },

    userOtherFile () {
      const list = []
      if (this.contractInfo.otherFiles?.files) {
        const files = this.contractInfo.otherFiles?.files
        Object.keys(files).forEach(key => {
          // 后缀获取
          let suffix = ''
          // 获取类型结果
          let result = ''
          try {
            const flieArr = files[key].split('.')
            suffix = flieArr[flieArr.length - 1]
          } catch (err) {
            suffix = ''
          }
          // fileName无后缀返回 false
          if (!suffix) {
            result = false
            return result
          }

          list.push({
            type: suffix,
            url: files[key],
            id: key,
            name: key
          })
        })
      }
      return list
    },

    userResume () {
      return formatFiles(this.contractInfo, 'resume')
    }
  },

  watch: {
    currPage (n) {
      this.getListing()
    },

    'contractInfo.countryId': {
      handler (newV, oldV) {
        if (!newV) {
          this.contractInfo.cityId = null
        }
      }
    }
  },

  created () {
    if (localStorage.getItem('countrysSpare')) {
      this.countrys = JSON.parse(localStorage.getItem('countrysSpare'))
    } else {
      getCountrySpareList().then((res) => {
        this.countrys = res.data
        localStorage.setItem('countrysSpare', JSON.stringify(res.data))
      })
    }
    // this.citys = this.$store.state.user.user.city ? [this.$store.state.user.user.city] : []
    this.countryId = this.$store.state.user.user.country?.id || null
    if (this.$store.state.user.user.country?.id) {
      searchAddress({ type: 'city', page: 1, cid: this.countryId }).then(res => { this.citys = [...res.data, this.modelValue.city] })
    }
    getUserTitle().then(res => {
      this.userTitle = res.data
      this.$emit('updateValue')
    })
  },

  mounted () {
  },

  methods: {
    searchCity (countryId) {
      this.countryId = countryId
      this.contractInfo.cityId = null
      const selectedCountry = this.countrys.find(c => c.id === countryId)
      this.contractInfo.phonecode = selectedCountry.phonecode
      searchAddress({ type: 'city', page: 1, cid: countryId }).then(res => {
        this.citys = res.data
      })
    },

    searchCityByKey (key) {
      searchAddress({ type: 'city', page: 1, cid: this.countryId, keyWord: key }).then(res => { this.citys = res.data })
    }
  }
}
</script>

<style scoped lang="less">
.Contract{
  .uploadFile{
    position: relative;
    top: -4px;
  }
  .label-content{
    .label{
      width: 200px;
    }
  }
  .left-side{
    .contract-info-input{
      //pd-b-40 pd-l-20 pd-t-20
      padding: @gap 0 @gap*2 @gap;
      // min-width: 860px;
    }
  }
  .right-side{
    background-color: white;
    .main,.department-info{
      padding: @gap @gap @gap @gap*2;
    }
    .department-info{
      .info-detail{
        .item{
          width:100%;
          -webkit-display:flex;
          -ms-display:flex;
          display:flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          -ms-justify-content: space-between;
          vertical-align: text-top;
          line-height: 1em;
          p{
            margin: @gap/5 0 @gap/5 0;
            font-size: 12px;
          }
          .left{
            flex:0 0 30%;
            text-align: right;
          }
          .right{
            flex:0 0 65%;
            text-align: left;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .tip{
    opacity: 0.6;
    font-size: 12px;
    margin: 0 0 @gap/2 0;
  }
}
.icon-panel {
  padding-left: 10px;
  .iconfont {
    font-size: 22px;
  }
}
.fn-span{
  position: absolute;
  top: -14px;
  color: #000000;
  opacity: 0.8;
  z-index: 99;
}
.content-form{
  .right{
    width: 139px;
  }
  .icon-panel{
    width: 32px;
    box-sizing: border-box;
  }
}
.avatar-panel {
  position: relative;
  top: -14px;
  .name-label {
    margin: 0;
  }
  .avatar-uploader{
    width: 198px;
    height: 240px;
    position: absolute;
    top: 14px;
  }
}
.tel-area{
  height: 44px;
  line-height: 44px;
  width: 100px;
  font-size: 14px;
  text-align: left;
  background-color: #efefef;
  padding: 0 4px;
  word-wrap: break-word;
  white-space: nowrap;
  text-align: center;
}
</style>

<style lang="less">
.cus-disabled-choose{
  .SpChoose{
    &[disabled='true']{
      label{
        .label{
          opacity: 1;
        }
      }
    }
  }
}
.SpInput{
  &.size-8{
    input {
      font-size: 12px;
    }
  }
}
</style>
